const removeQueryStringParams = (url, excludeMonth = false) => {
  if (!url.includes('?')) return url;

  const [formattedUrl, queryString] = url.split('?');
  const params = new URLSearchParams(queryString);

  if (excludeMonth) {
    const filteredParams = new URLSearchParams();
    if (params.has('month')) filteredParams.set('month', params.get('month'));
    if (params.has('year')) filteredParams.set('year', params.get('year'));

    const newQueryString = filteredParams.toString();

    return newQueryString ? `${formattedUrl}?${newQueryString}` : formattedUrl;
  }

  return formattedUrl;
};

export default removeQueryStringParams;
